import { render, staticRenderFns } from "./KeyAssignment.vue?vue&type=template&id=db3e0140&scoped=true"
import script from "./KeyAssignment.vue?vue&type=script&lang=js"
export * from "./KeyAssignment.vue?vue&type=script&lang=js"
import style0 from "./KeyAssignment.vue?vue&type=style&index=0&id=db3e0140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3e0140",
  null
  
)

export default component.exports